import { combineReducers } from "redux";
import loanStatusReducer from "./LoanStatusReducer";
import alertReducer from "./AlertReducer";
import { MessageReducer } from "./messageReducer";

const rootReducer = combineReducers({
    loanStatus: loanStatusReducer,
    alertDetails: alertReducer,
    messages: MessageReducer,
});

export default rootReducer;